import get from "lodash.get";
import ReportsActionTypes from "./types";
import AbstractApiReducer from "services/cores/abstractApiReducer";

const INITIAL_REPORTS_STATE = {
  weeklyList: {
    initialized: false,
    selectedIndex: undefined,
    hoverIndex: undefined,
    items: [],
    frequency: "weekly",
    orders: {},
    length: 0,
    page: 0,
    rowsPerPage: 10,
  },
  monthlyList: {
    initialized: false,
    selectedIndex: undefined,
    hoverIndex: undefined,
    items: [],
    frequency: "monthly",
    orders: {},
    length: 0,
    page: 0,
    rowsPerPage: 10,
  },
};

class ReportsReducer extends AbstractApiReducer {
  constructor() {
    super(ReportsActionTypes, INITIAL_REPORTS_STATE);
    this.mapActionToMethods[ReportsActionTypes.SET_INITIALIZED] =
      this.setInitializedAction;
    this.mapActionToMethods[ReportsActionTypes.SET_LIST] = this.setListAction;
    this.mapActionToMethods[ReportsActionTypes.SET_LIST_PAGE] =
      this.setListPageAction;
    this.mapActionToMethods[ReportsActionTypes.SET_LIST_ROWS_PER_PAGE] =
      this.setListRowsPerPageAction;
    this.mapActionToMethods[ReportsActionTypes.SET_LIST_SELECTED_INDEX] =
      this.setListSelectedIndexAction;
  }

  setListAction(state, action) {
    const key = get(action, "key", "list");

    return {
      ...state,
      [key]: {
        ...get(state, key, {}),
        selectedIndex: undefined,
        hoverIndex: undefined,
        initialized: true,
        items: get(action, "value.items", []),
        length: get(
          action,
          "value.length",
          get(action, "value.items", []).length
        ),
      },
    };
  }

  setInitializedAction(state, action) {
    const key = get(action, "key", "list");

    return {
      ...state,
      [key]: {
        ...get(state, key, {}),
        initialized: action.value,
      },
    };
  }

  setListHoverIndexAction(state, action) {
    const key = get(action, "key", "list");

    return {
      ...state,
      [key]: {
        ...get(state, key, {}),
        hoverIndex: action.value,
      },
    };
  }

  setListPageAction(state, action) {
    const key = get(action, "key", "list");

    return {
      ...state,
      [key]: {
        ...get(state, key, {}),
        page: action.value,
      },
    };
  }

  setListRowsPerPageAction(state, action) {
    const key = get(action, "key", "list");

    return {
      ...state,
      [key]: {
        ...get(state, key, {}),
        rowsPerPage: action.value,
      },
    };
  }

  setListSelectedIndexAction(state, action) {
    const key = get(action, "key", "list");

    return {
      ...state,
      [key]: {
        ...get(state, key, {}),
        selectedIndex: action.value,
      },
    };
  }
}

const instance = new ReportsReducer();
export default instance.reducer;
